import { createRouter, createWebHistory } from "@ionic/vue-router";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import TabsPage from "../views/TabsPage.vue";
import RegisterPage from "../views/RegisterPage.vue";
import AdminPage from "../views/AdminPage.vue";
import GuruPage from "../views/GuruPage.vue";
import SiswaPage from "../views/SiswaPage.vue";
import PetugasPage from "../views/PetugasPage.vue";
import OrangTuaPage from "../views/OrangTuaPage.vue";
import UmumPage from "../views/UmumPage.vue";

const routes = [
  {
    path: "/",
    redirect: "/page",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginPage.vue"),
  },
  {
    path: "/splash",
    name: "splash",
    component: () => import("@/views/SplashScreen.vue"),
  },
  {
    path: "/page/",
    component: TabsPage,
    children: [
      {
        path: "",
        redirect: "/page/home",
      },
      {
        path: "home",
        name: "home",
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
          const auth = getAuth();
          const db = getFirestore();

          const checkUserRole = async (user) => {
            if (user) {
              const userDoc = await getDoc(doc(db, "users", user.uid));
              if (userDoc.exists()) {
                const userData = userDoc.data();
                const userRole = userData.role;

                // Pengalihan berdasarkan peran pengguna
                if (userRole === "admin") {
                  next({ name: "admin" });
                } else if (userRole === "guru") {
                  next({ name: "guru" });
                } else if (userRole === "petugas") {
                  next({ name: "guru" });
                } else if (userRole === "siswa") {
                  next({ name: "siswa" });
                } else if (userRole === "umum") {
                  next({ name: "umum" });
                } else {
                  next(); // Pengalihan default jika peran tidak dikenali
                }
              } else {
                next({ name: "login" }); // Pengguna tidak ditemukan di Firestore
              }
            } else {
              next({ name: "login" }); // Pengguna tidak terautentikasi
            }
          };

          onAuthStateChanged(auth, (user) => {
            if (user) {
              checkUserRole(user).catch((error) => {
                console.error(error);
                next({ name: "login" });
              });
            } else {
              next({ name: "login" });
            }
          });
        },
      },
      {
        path: "/siswa",
        name: "siswa",
        component: SiswaPage,
      },
      {
        path: "/admin",
        name: "admin",
        component: AdminPage,
        meta: { requiresAuth: true, role: 'admin' }
      },
      {
        path: "/guru",
        name: "guru",
        component: GuruPage,
        meta: { requiresAuth: true, role: 'guru' }
      },
      {
        path: "/petugas",
        name: "petugas",
        component: PetugasPage,
      },
      {
        path: "/orangtua",
        name: "orangtua",
        component: OrangTuaPage,
      },
      {
        path: "/umum",
        name: "umum",
        component: UmumPage,
      },
      {
        path: "soalsoal/:menuId",
        name: "soalsoal",
        component: () => import("@/views/SoalSoal/SoalSoal.vue"),
      },
      // Halaman Admin
      {
        path: "admin/laporankehadiran",
        name: "laporankehadiranAdmin",
        component: () => import("@/views/admin/LaporanKehadiran.vue"),
        meta: { requiresAuth: true, role: 'admin' }
      },
      {
        path: "admin/laporanizin",
        name: "laporanizinAdmin",
        component: () => import("@/views/admin/LaporanIzin.vue"),
        meta: { requiresAuth: true, role: 'admin' }
      },
      {
        path: "admin/halamanpengguna",
        name: "halamanpenggunaAdmin",
        component: () => import("@/views/admin/HalamanPengguna.vue"),
        meta: { requiresAuth: true, role: 'admin' }
      },
      {
        path: "admin/halamansetting",
        name: "halamansettingAdmin",
        component: () => import("@/views/admin/HalamanSetting.vue"),
        meta: { requiresAuth: true, role: 'admin' }
      },
      {
        path: "admin/halamanshorts",
        name: "halamanshortsAdmin",
        component: () => import("@/views/admin/HalamanShorts.vue"),
        meta: { requiresAuth: true, role: 'admin' }
      },
      {
        path: "admin/halamankelas",
        name: "halamankelas",
        component: () => import("@/views/admin/TambahKelas.vue"),
        meta: { requiresAuth: true, role: 'admin' }
      },
      {
        path: "admin/halamanmatapelajaran",
        name: "halamanmatapelajaran",
        component: () => import("@/views/admin/TambahMatePelajaran.vue"),
      },

      // Halaman Guru
      {
        path: "guru/laporankehadiran",
        name: "laporankehadiranGuru",
        component: () => import("@/views/guru/LaporanKehadiran.vue"),
        meta: { requiresAuth: true, role: 'guru' }
      },
      {
        path: "guru/laporanizin",
        name: "laporanizinGuru",
        component: () => import("@/views/guru/LaporanIzin.vue"),
        meta: { requiresAuth: true, role: 'guru' }

      },
      {
        path: "guru/halamanpengguna",
        name: "halamanpenggunaGuru",
        component: () => import("@/views/guru/HalamanPengguna.vue"),
        meta: { requiresAuth: true, role: 'guru' }
      },
      {
        path: "guru/halamansetting",
        name: "halamansettingGuru",
        component: () => import("@/views/guru/HalamanSetting.vue"),
        meta: { requiresAuth: true, role: 'guru' }
      },
      {
        path: "guru/tambahsoal",
        name: "tambahsoalGuru",
        component: () => import("@/views/guru/TambahSoal.vue"),
        meta: { requiresAuth: true, role: 'guru' }
      },
      {
        path: "guru/tambahsoalcpns",
        name: "tambahsoalCpns",
        component: () => import("@/views/guru/SoalCpns.vue"),
      },
      {
        path: "guru/TryOutCpns",
        name: "TryOutCpns",
        component: () => import("@/views/guru/TryOutCpns.vue"),
        meta: { requiresAuth: true, role: 'guru' }
      },
      {
        path: "guru/tambahsoalkedinasan",
        name: "tambahsoalkedinasan",
        component: () => import("@/views/guru/SoalKedinasan.vue"),
        meta: { requiresAuth: true, role: 'guru' }
      },
      {
        path: "guru/TryOutKedinasan",
        name: "TryOutKedinasan",
        component: () => import("@/views/guru/TryOutKedinasan.vue"),
        meta: { requiresAuth: true, role: 'guru' }
      },
      {
        path: "guru/tambahsoalsnbt",
        name: "tambahsoalsnbt",
        component: () => import("@/views/guru/SoalSnbt.vue"),
        meta: { requiresAuth: true, role: 'guru' }
      },
      {
        path: "guru/TryOutSnbt",
        name: "TryOutSnbt",
        component: () => import("@/views/guru/TryOutSnbt.vue"),
      },
      {
        path: "guru/tambahmateri",
        name: "tambahmateriGuru",
        component: () => import("@/views/guru/TambahMateri.vue"),
        meta: { requiresAuth: true, role: 'guru' }
      },
      {
        path: "guru/buatujian",
        name: "buatujianGuru",
        component: () => import("@/views/guru/JadwalUjian.vue"),
        meta: { requiresAuth: true, role: 'guru' }
      },
      {
        path: "guru/lihathasilujianguru",
        name: "lihatHasilUjianGuru",
        component: () => import("@/views/guru/LihatNilai.vue"),
      },
      {
        path: "guru/lihatHasilKedinasan",
        name: "lihatHasilKedinasan",
        component: () => import("@/views/guru/LihatNilaiSnbt.vue"),
        meta: { requiresAuth: true, role: 'guru' }
      },
      {
        path: '/guru/HasilUjianSnbt/:jadwalId', // Tambahkan :jadwalId sebagai parameter
        name: 'HasilUjianSnbt',
        component: () => import('@/views/guru/HasilUjianSnbt.vue'),
        props: true, // Agar jadwalId bisa diakses di dalam komponen
        meta: { requiresAuth: true, role: 'guru' }
      },

      {
        path: '/guru/HasilUjianKedinasan/:jadwalId', // Tambahkan :jadwalId sebagai parameter
        name: 'HasilUjianKedinasan',
        component: () => import('@/views/guru/HasilUjianKedinasan.vue'),
        props: true, // Agar jadwalId bisa diakses di dalam komponen
        meta: { requiresAuth: true, role: 'guru' }
      },
      {
        path: '/hasil-ujian/:id',
        name: 'HasilUjian',
        component: () => import('@/views/guru/HasilUjianReguler.vue'),
        meta: { requiresAuth: true, role: 'guru' }
      },


      // Halaman Petugas
      {
        path: "petugas/laporankehadiran",
        name: "laporankehadiranPetugas",
        component: () => import("@/views/petugas/LaporanKehadiran.vue"),
      },
      {
        path: "petugas/laporanizin",
        name: "laporanizinPetugas",
        component: () => import("@/views/petugas/LaporanIzin.vue"),
      },
      {
        path: "petugas/halamanpengguna",
        name: "halamanpenggunaPetugas",
        component: () => import("@/views/petugas/HalamanPengguna.vue"),
      },
      {
        path: "petugas/halamansetting",
        name: "halamansettingPetugas",
        component: () => import("@/views/petugas/HalamanSetting.vue"),
      },

      // Halaman Umum
      {
        path: "user/halamanujianumum/:jadwalId",
        name: "halamanujianUmum",
        component: () => import("@/views/umum/HalamanUjianUmum.vue"),
      },

      // Halaman user
      {
        path: '/semua-ujian-snbt',
        name: 'SemuaUjianSnbt',
        component: () => import('@/views/user/SemuaUjianSnbt.vue'),
      },
      {
        path: "user/laporankehadiran",
        name: "laporankehadiranUser",
        component: () => import("@/views/user/LaporanKehadiran.vue"),
      },
      {
        path: "user/raport",
        name: "raport",
        component: () => import("@/views/user/RaportPage.vue"),
      },
      {
        path: "user/ebook",
        name: "ebook",
        component: () => import("@/views/user/EbookPage.vue"),
      },
      {
        path: "user/games",
        name: "games",
        component: () => import("@/views/user/GamesPage.vue"),
      },
      {
        path: "user/game-sederhana",
        name: "gameSederhana",
        component: () => import("@/views/user/GameSederhanaPage.vue"),
      },
      {
        path: "user/game-visual-novel",
        name: "gameVisualNovel",
        component: () => import("@/views/games/GameVisualNovelPage.vue"),
      },
      {
        path: "user/game-arcade",
        name: "gameArcade",
        component: () => import("@/views/games/GameArcadePage.vue"),
      },
      {
        path: "user/game-tts",
        name: "gameTts",
        component: () => import("@/views/games/GameTtsPage.vue"),
      },
      {
        path: "user/laporanizin",
        name: "laporanizinUser",
        component: () => import("@/views/user/LaporanIzin.vue"),
      },
      {
        path: "user/halamanpengguna",
        name: "halamanpenggunaUser",
        component: () => import("@/views/user/HalamanPengguna.vue"),
      },
      {
        path: "user/halamansetting",
        name: "halamansettingUser",
        component: () => import("@/views/user/HalamanSetting.vue"),
      },
      {
        path: "user/halamanshort",
        name: "halamanShortsUser",
        component: () => import("@/views/HalamanShort.vue"),
      },
      {
        path: "user/halamanai",
        name: "halamanAiUser",
        component: () => import("@/views/HalamanAi.vue"),
      },
      {
        path: "user/halamanujian/:jadwalId",
        name: "halamanujianUser",
        component: () => import("@/views/user/HalamanUjian.vue"),
      },
      {
        path: "user/jadwalujian",
        name: "jadwalujianUser",
        component: () => import("@/views/user/JadwalUjian.vue"),
      },
      {
        path: "user/lihathasilujian",
        name: "lihathasilujianUser",
        component: () => import("@/views/user/LihatHasilUjian.vue"),
      },
      {
        path: "/user/lihatmaterimateri/:materiId",
        name: "lihatmaterimateri",
        component: () => import("@/views/user/HalamanMateri.vue"),
      },
      {
        path: "ujiankedinasan/:jadwalId",
        name: "ujiankedinasan",
        component: () => import("@/views/user/UjianKedinasanDetail.vue"), // Pastikan komponen detail sudah ada
      },
      {
        path: "ujiansnbt/:jadwalId",
        name: "ujiansnbt",
        component: () => import("@/views/user/UjianDetailSnbt.vue"), // Pastikan komponen detail sudah ada
      },
      {
        path: "ujianreguler/:jadwalId",
        name: "ujianreguler",
        component: () => import("@/views/user/UjianDetailReguler.vue"), // Pastikan komponen detail sudah ada
      },
      {
        path: "explanation/:jadwalId", // Rute baru untuk halaman pembahasan
        name: "explanation",
        component: () => import("@/views/user/ExplanationPage.vue"), // Pastikan file ExplanationPage.vue ada di direktori

      },
      {
        path: "explanationkedinasan/:jadwalId", // Rute baru untuk halaman pembahasan
        name: "explanationkedinasan",
        component: () => import("@/views/user/ExplanationPageKedinasan.vue"), // Pastikan file ExplanationPage.vue ada di direktori

      },
    ],
  },
  {
    path: "/register",
    name: "register",
    component: RegisterPage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const auth = getAuth();

  // Jika rute tidak membutuhkan autentikasi, lanjutkan
  if (!to.meta.requiresAuth) {
    return next();
  }

  try {
    // Tunggu hingga auth siap
    await auth.authStateReady();
    const user = auth.currentUser;

    // Jika tidak ada user, redirect ke login
    if (!user) {
      return next({ name: "login" });
    }

    // Verifikasi token (tanpa force refresh)
    const token = await user.getIdTokenResult();

    // Cek apakah token masih valid
    if (new Date() > new Date(token.expirationTime)) {
      // Token expired, logout
      await auth.signOut();
      return next({ name: "login" });
    }

    // Cek data user di Firestore
    const db = getFirestore();
    const userDoc = await getDoc(doc(db, "users", user.uid));

    if (!userDoc.exists()) {
      await auth.signOut();
      return next({ name: "login" });
    }

    const userData = userDoc.data();
    const userRole = userData.role;

    // Cek role jika diperlukan
    if (to.meta.role && to.meta.role !== userRole) {
      return next({ name: "home" });
    }

    // Semua valid, lanjutkan
    return next();

  } catch (error) {
    console.error("Auth error:", error);
    await auth.signOut();
    return next({ name: "login" });
  }
});



export default router;
